import { LeaderboardType } from './types';

export const MAX_GROUP_NAME_LENGTH = 128;
export const MAX_GROUP_ITEM_COUNT = 2000;
export const MAX_TOTAL_GROUP_ITEM_COUNT = 5500;
export const CELL_VALUE_MULTIPLE = 'multiple';
export const STICKY_EXCEL_ROW_COUNT = 11;
export const DISABLED_LABLES = {
  others: 'Others',
  tradebrandsAndExclusives: 'Tradebrands and exclusives',
  suppressed: 'Suppressed',
  tradebrand: 'Tradebrand',
};

export const MODEL_IDS_DELIMITER = ',';
export const GROUP_DELIMITER = '|';
export const LEADERBOARD_ROWID_MAP = {
  item_id: LeaderboardType.Product,
  brand_name: LeaderboardType.Brand,
  region_name: LeaderboardType.Region,
  segment_feature: LeaderboardType.SegmentFeature,
  product_feature: LeaderboardType.ProductFeature,
  country_code: LeaderboardType.Country,
  item_group_code: LeaderboardType.ProductGroup,
};
export const MAX_PRICE_CLASSES_NAME_LENGTH = 32;
